@import (reference) '../../../constants/spacing.module.less';

.inline-navigation-buttons {
  display: flex;
  align-items: center;
  gap: @space-8;
}
